import { createFeatureSelector, createSelector } from '@ngrx/store';
import { isDefined } from '@sites/dashboard/util';
import { FileKey, FileState } from './file.reducer';

const selectFileState = createFeatureSelector<FileState>(FileKey);

export const selectFileByKey = (key: string) =>
  createSelector(selectFileState, (state) => {
    return state.entities[key];
  });

export const selectFilesByKeys = (keys: string[]) =>
  createSelector(selectFileState, (state) => {
    return keys.map((key) => state.entities[key]).filter(isDefined);
  });

export const selectFiles = createSelector(selectFileState, (state) => {
  return state.entities;
});

export const selectFileUrlByKey = (key: string) =>
  createSelector(selectFileState, (state) => {
    return state.entities[key]?.url;
  });
